import { IFileMetadataEntity } from "@odata/GeneratedEntityTypes";
import React, { useCallback } from "react";

import FileStorage from "../../utils/FileStorage";
import { ChatMessageAttachmentsStyled } from "./ChatMessage.styles";
import MessageFile from "./MessageFile";

interface IProps {
    attachments: IFileMetadataEntity[];
}

const ChatMessageAttachments: React.FC<IProps> = ({ attachments }) => {

    const handleDownload = useCallback((id: number) => {
        FileStorage.download(id);
    }, []);

    return attachments?.length ? (
        <ChatMessageAttachmentsStyled>
            {attachments.map(a => (
                <MessageFile key={a.Id} id={a.Id} name={a.Name} onClick={handleDownload}/>
            ))}
        </ChatMessageAttachmentsStyled>
    ) : null;
};

export default ChatMessageAttachments;